import { render, staticRenderFns } from "./CouponGeneralConditions.vue?vue&type=template&id=2438c498&"
import script from "./CouponGeneralConditions.vue?vue&type=script&lang=ts&"
export * from "./CouponGeneralConditions.vue?vue&type=script&lang=ts&"
import style0 from "./CouponGeneralConditions.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports